<template>
	<div class="container-cookies" v-if="cookiesStore.acceptCookies === null" :class="{bottom}">
		<div class="row-cookies">
			<div class="container-image-cookies">
				<img src="https://img.qromo.io/img/icon-cookies.svg" alt="icon cookies">
			</div>
			<div class="content-cookies">
				<div class="row-content-cookies">
					<p>{{ getString("use_cookies_title") }}</p>
					<AppDropdown :collapsed="collapsedCookies" >
						<p class="cookies-explain"><span>{{ getString('click_here_to_view')+" " }}</span><a target="_blank" :href="urlCookiePolicy">{{ getString('the_cookie_policy')+". " }}</a><span>{{ getString('cookie_info') }}</span></p>
					</AppDropdown>
				</div>
				<div class="container-arrow-search" @click="collapsedCookies = !collapsedCookies"><AppChevronIcon :direction="collapsedCookies ? 'down' : 'up'" :color="'#'+baseColor" /></div>
			</div>
			<div class="inputs-cookies">
				<div id="container-cta-cards" class="container-button container-button-cta  container-button-cta-cookies  container-button-cta-cookies-negative">
					<div class="input-button" @click="chooseCookie(false)">{{ getString('no') }}</div>
				</div>
				<div id="container-cta-cards" class="container-button container-button-cta container-button-cta-cookies">
					<div class="input-button" @click="chooseCookie(true)">{{ getString('ok') }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore, useSvgStore, useCookiesStore} from "@/shared/stores";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";

export default {
	setup() {
		let svgStore = useSvgStore();
		let languageStore = useLanguageStore();
		let cookiesStore = useCookiesStore();
		return {svgStore, cookiesStore, getString: languageStore.getString}
	},
	components: {AppDropdown, AppChevronIcon},
	name: "BannerCookie",
	props: {
		baseColor: { default: '0752a3' },
		bottom: { type: Boolean, default: false },
	},
	data() {
		return {
			collapsedCookies: true,
		}
	},
	computed: {
		urlCookiePolicy() {
			const currentProtocol = window.location.protocol;
			const currentHost = window.location.host;
			return currentProtocol + '//' + currentHost + '/cookies/';
		}
	},
	methods: {
		chooseCookie(accept) {
			this.cookiesStore.toggleCookiesChoice(accept);
			this.$emit("cookies-chosen", accept);
		}
	},
	created() {

		this.cookiesStore.initConsent();

	}
}
</script>

<style scoped lang="scss">
.container-cookies {
	position: fixed;
	display: flex;
	flex-direction: column;
	top: 40px;
	right: calc((100% / 3) + (var(--padding-horizontal) * 2));
	width: calc(65% - 65px);
	background-color: var(--theme-bg1-color, #0752A3);
	border-radius: var(--rounded-corner, 13px);
	z-index: 999999;
	box-shadow: var(--theme-box-shadow, 0 0 33px 0 rgba(7, 16, 32, 0.4));
	padding: 6px 20px;
	box-sizing: border-box;
	max-width: 650px;
	margin-left: 0;
	opacity: 1;
	transition: opacity 0.5s ease, transform 0.3s ease;
	transform: translateX(0);

	@media (max-width: 1024px) {
		left: unset;
		right: calc(var(--padding-horizontal) * 2);
		width: calc(100% - (var(--padding-horizontal) * 4));
	}

	@media (max-width: 450px) {
		padding: 6px 12px;
	}

	&.invisible {
		opacity: 0;
		transform: translateX(50px);
		visibility: hidden;
	}

	.row-cookies {
		display: flex;
		justify-content: space-between;

		.container-image-cookies {
			position: absolute;
			top: -25px;
			left: -25px;
			width: 46px;
			height: 46px;
			flex-shrink: 0;

			img {
				object-fit: contain;
				width: 100%;
				height: 100%;
			}

			@media (max-width: 450px) {
				top: -24px;
				left: -15px;
				width: 35px;
				height: 35px;
			}
		}

		.content-cookies {
			display: flex;
			align-items: center;
			flex-grow: 1;

			.row-content-cookies {
				display: flex;
				flex-direction: column;
				flex-grow: 1;

				&:deep(.dropdown-content) {
					background-color: transparent;
					padding: 0;
					margin-top: 4px;
					box-shadow: none;
				}

			}

			p {
				font-size: var(--font-size-s, 16px);
				line-height: var(--line-height-s, 20px);
				padding-right: 20px;
				margin: 0;
				color: var(--theme-txt2-color, #fff);

			}

			.container-arrow-search {
				width: 35px;
				min-width: 35px;
				height: 35px;
				border-radius: var(--rounded-corner, 13px);
				transition: transform .15s ease;
				cursor: pointer;
				background-color: var(--theme-bg2-color, rgba(255, 255, 255, 0.1));
				display: flex;
				justify-content: center;
				align-items: center;

				span {
					height: 16px;
				}
			}
		}

		.inputs-cookies {
			display: flex;
			box-sizing: border-box;
			align-items: center;
			justify-content: center;
			gap: 8px;
			margin-left: 8px;

			@media (max-width: 420px) {
				flex-direction: column;
				gap: 2px;
			}

			.container-button-cta-cookies {
				cursor: pointer;

				.input-button {
					padding: 7px 15px;
					font-size: var(--font-size, 16px);
					line-height: var(--line-height, 20px);
					background-color: var(--business-color, #29edc0);
					color: var(--business-text-color, #2353a2);
					border-radius: var(--rounded-corner-s, 13px);
					box-shadow: var(--theme-box-shadow-xlight, 3px 3px 7.5px -3px rgba(0, 0, 0, 0.4));

					@media (max-width: 420px) {
						padding: 3px 14px;
					}
				}

				&-negative .input-button {
					background-color: transparent !important;
					color: var(--business-color, #29edc0) !important;
					box-shadow: none;

					@media (max-width: 420px) {
						order: 2;
					}
				}

			}
		}
	}

	&.bottom {
		top: unset;
		bottom: 40px;
		right: 40px;

		@media (max-width: 730px) {
			max-width: calc(100% - 80px);
		}

		@media (max-width: 400px) {
			max-width: calc(100% - 40px);
			right: 20px;
		}

		@media (max-width: 360px) {
			max-width: calc(100% - 30px);
			right: 10px;
		}

		.row-cookies {
			.inputs-cookies {
				.container-button-cta-cookies-negative {
					.input-button {
						border: 1px solid var(--business-color, #29edc0);
					}
				}
			}
		}
	}
}
.cookies-explain {

	span,a {
		font-size: var(--font-size-s, 16px);
		line-height: var(--line-height-s, 20px);
		color: var(--theme-txt2-color, #fff);
	}
}
</style>